const KEY = 'lead_source';

export const setLeadSource = (source) => {
  if (source) sessionStorage.setItem(KEY, source);
};

export const getLeadSource = () => sessionStorage.getItem(KEY) || '';
